<template>
	<div class="news">
		<Breadcrumb :crumb="crumb"></Breadcrumb>
		<div class="banner">
			<img src="../../assets/images/news/banner.png" />
		</div>
		<div class="news-box">
			<div class="list">
				<div @click="go2article(item)" class="item" v-for="(item,index) in list" :key="index">
					<img :src="item.image_main" />
					<div class="item-content">
						<div class="top">
							<div class="title">{{ item.title }}</div>
							<div class="time">{{ item.create_time }}</div>
						</div>
						<div class="content" >
							{{  }}
						</div>
					</div>
				</div>
				<div style="margin-top:20px;">
					<Page :current="page" :total="total" @on-change="changePage" show-total></Page>
				</div>
			</div>
			<div class="hot-list">
				<div class="hot-title">热点新闻</div>
				<div class="hot-box">
					<div @click="go2article(item)" class="item" v-for="(item,index) in hotList" :key="index">
						<img :src="item.image_main" />
						<div class="item-content">
							<div class="title">{{ item.title }}</div>
							<div class="content"> {{ item.content }} </div>
							<div class="time">{{ item.create_time }}</div>
						</div>
					</div>

				</div>
			</div>

		</div>
	</div>

</template>

<script>
	import Breadcrumb from "@/components/Breadcrumb.vue";
	import { getContentList, getContentHotList } from "@/api"
	export default {
		name: "Fashionshow",
		components: {
			Breadcrumb,
		},
		data() {
			return {
				crumb: [{
					title: "新闻资讯",
					path: "news",
				}, ],
				page:1,
				total:0,
				size:10,
				list: [],
				hotList:[]
			};
		},
		created() {
			this.getList()
			this.getHotList()
		},

		methods: {
			changePage(page) {
				this.page = page
				this.getList()
			},
			getHotList() {
				getContentHotList({
					page:1,
					size:5
				}).then((res)=>{
					this.hotList = res.data.list
				})
			},
			async getList() {
				let json = await getContentList({
					page:this.page,
					size:this.size
				})
				this.list = json.data.list
				this.total = json.data.count
			},
			go2article(article) {
				if (article.show_type == 9) {
					window.open(article.external_link)
				} else {
					this.$router.push({
						path: '/detail',
						query: {
							id: article.content_id
						}
					})
				}
			},
		},
	};
</script>

<style scoped lang="scss">
	.news {
		width: 1170px;
		margin: 20px auto;

		.banner {
			margin-top: 20px;
			width: 100%;
			height: 200px;
		}

		.news-box {
			margin: 20px 0;
			display: flex;
			justify-content: space-between;
			width: 100%;

			.list {
				width: 870px;

				.item {
					display: flex;
					align-items: center;
					font-size: 14px;
					font-family: PingFang SC;
					font-weight: 400;
					line-height: 20px;
					color: #666666;
					border-bottom: 1px solid #dddddd;
					padding: 10px 0;
					margin: 0 10px;

					img {
						width: 250px;
						height: 117px;
					}

					.item-content {
						height: 100%;
						margin-left: 20px;
						width: 68%;

						.top {
							display: flex;
							justify-content: space-between;
							align-items: center;

							.title {
								font-size: 16px;
								font-weight: bold;
								line-height: 22px;
								color: #333333;
							}

							.time {
								font-size: 15px;
								font-family: PingFang SC;
								font-weight: 400;
								line-height: 21px;
								color: #999999;
							}
						}

						.content {
							margin-top: 10px;
							font-size: 14px;
							font-family: PingFang SC;
							font-weight: 400;
							line-height: 20px;
							color: #666666;
						}
					}
				}
			}

			.hot-list {
				margin-left: 20px;
				width: 280px;

				.hot-title {
					width: 280px;
					height: 60px;
					line-height: 60px;
					background: #0f114a;
					text-align: center;
					color: #ffffff;
					font-size: 18px;
					font-family: PingFang SC;
					font-weight: bold;
				}

				.hot-box {
					width: 100%;
					border: 1px solid #eeeeee;

					.item {
						display: flex;
						align-items: center;
						padding: 10px 0;
						height: 100px;
						margin: 0 10px;

						img {
							width: 80px;
							height: 80px;
						}

						.item-content {
							width: 168px;
							font-size: 12px;
							color: #666666;
							height: 100%;
							margin-left: 10px;

							.title {
								overflow: hidden;
								text-overflow: ellipsis;
								white-space: nowrap;
								color: #333333;
								font-size: 14px;
							}

							.content {
								height: 34px;
								width: 100%;
								margin: 5px 0;
								overflow: hidden;
								text-overflow: ellipsis;
								display: -webkit-box;
								-webkit-line-clamp: 2;
								-webkit-box-orient: vertical;
							}
						}
					}
				}
			}
		}
	}
</style>
